'use client'
import * as React from 'react'
import {getLatestThreeBlogs} from '../blogs/wordpress'
import styles from '../blogs/styles.module.css'
import Link from 'next/link'
import classes from './styles.module.css'
import {Blog} from 'types/blogs'
import BlogCard from '../blogs/components/blog-card/BlogCard'
import readTimeEstimate from 'read-time-estimate'
import Image from 'next/image'
import ArrowLeftIcon from 'v1/assets/icons/zenhr/home/arrow-left.svg'

const RecommendedBlogs = ({id}: {id: string}) => {
  const [blogs, setBlogs] = React.useState<Blog[] | undefined>([])

  React.useEffect(() => {
    const getBlogs = async () => {
      try {
        let blogs = await getLatestThreeBlogs({page_number: 1})
        if (blogs?.length) {
          blogs = blogs?.filter(blog => blog.id !== id)
        }
        setBlogs(blogs?.slice(-3))
      } catch (error) {
        console.log({error})
      }
    }
    getBlogs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBlogReadingTime = (string: string) => {
    const {humanizedDuration} = readTimeEstimate(string, 275, 12, 500, ['img', 'Image'])
    return humanizedDuration
  }

  return (
    <div>
      <div className={classes.nextBlogTitle}>You might also like</div>
      <div className={styles.container}>
        <div className={styles.blogContainer}>
          {blogs?.map((blog, index) => (
            <Link href={`/blogs/${blog.slug}`} key={index} className={styles.blog}>
              <BlogCard blog={blog} getBlogReadingTime={getBlogReadingTime} />
            </Link>
          ))}
        </div>
      </div>
      <Link href="/blogs" className={classes.backSection}>
        <div>
          <Image
            loading="lazy"
            className={classes.backIcon}
            src={ArrowLeftIcon}
            alt="login-icon"
            width={20}
            height={20}
          />
        </div>
        <div className={classes.backTxt}>Back to Blogs</div>
      </Link>
    </div>
  )
}

export default RecommendedBlogs
